/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSave} from '@fortawesome/pro-duotone-svg-icons';

const SavedParametersIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faSave} {...props} />
);

export default SavedParametersIcon;
